export const adacContactInformation = {
  name: 'ADAC Zuhause Versicherung AG',
  street: 'Hansastr. 19',
  postalCodeAndCity: '80686 München',
  phoneNumber: '089 76 76 38 38',
  dialNumber: '+498976763838',
};
